import { IStyleQuizQuestion } from '@graphql/StyleQuiz/fragments/style-quiz-question.graphql';
import useQuestionSet from '../hooks/useQuestionSet';
import { IQuestion } from '../hooks/Question';

export interface IStyleQuizQuestionWithNext extends IStyleQuizQuestion {
  nextQuestion?: IQuestion | null;
  nextUri?: string | null;
}

const withNextQuestion = (
  question: IStyleQuizQuestion
): IStyleQuizQuestionWithNext => {
  const questionSet = useQuestionSet();
  const questionSetQuestion = Object.values(questionSet).find(
    (setQuestion) => Number(setQuestion.id) === Number(question.id)
  );

  return {
    ...question,
    nextQuestion: questionSetQuestion?.nextQuestion,
    nextUri: questionSetQuestion?.nextUri,
  };
};

export default withNextQuestion;
